import { chevronLeftIcon, chevronRightIcon } from '../../../config/icons';
import { ECarouselVariant, TCarouselStore } from '../types';
import ControlBtn from './control-btn';

type Props = Pick<TCarouselStore, 'variant'> & {
  onNext: () => void;
  onPrev: () => void;
  isRTL?: boolean;
};

export default function ControlButtons({ variant, isRTL, onNext, onPrev }: Props) {
  const isDefault = variant === ECarouselVariant.Default;
  const isCompact = variant === ECarouselVariant.Compact;
  const isExtended = variant === ECarouselVariant.Extended;

  return (
    <>
      {!isCompact && (
        <>
          <ControlBtn
            isRounded
            onClick={isRTL ? onNext : onPrev}
            icon={isRTL ? chevronLeftIcon : chevronRightIcon}
            left={isDefault ? '10px' : undefined}
            right={isExtended ? '15px' : undefined}
            bottom={isExtended ? '15px' : undefined}
            data-treedistestid="button-carousel-prev"
          />

          <ControlBtn
            isRounded
            onClick={isRTL ? onPrev : onNext}
            icon={isRTL ? chevronRightIcon : chevronLeftIcon}
            right={isDefault ? '10px' : isExtended ? '60px' : undefined}
            bottom={isExtended ? '15px' : undefined}
            data-treedistestid="button-carousel-next"
          />
        </>
      )}
    </>
  );
}
